import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setAdresSelectMapZoom, setRouteItem, setSelectedItem, setSelectedRouteItem, updateRouteItem } from "../addLoad/addLoadSlice";
import { setSelectedRouteItemUpdate } from "../updateLoad/updateLoadSlice";
import { updateRoutePoint } from "../kmCalc/kmCalcSlice";

const initialState = {

    isLoadingGetAdresAutoComplete: false,
    adresAutoCompleteOptions: [],

    isLoadingGetAdresFromLatLng: false,
    getAdresFromLatLngResult: null,


}

export const getAdresAutoComplete = createAsyncThunk("address/getAdresAutoComplete", async({searchText, kmHesaplamaRouteItemId}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/GoogleServices/GetGoogleMapsAutoComplete?input=${searchText}`)
        if(kmHesaplamaRouteItemId){
            thunkApi.dispatch(updateRoutePoint({
                id: kmHesaplamaRouteItemId,
                locationOptions: data.predictions.filter(item => item.description.includes("Türkiye")),
            }))
        }

        return data.predictions
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getAdresFromLatLng = createAsyncThunk("address/getAdresFromLatLng", async({lat, lng, isFromSingleRouteMap, isFromSingleRouteMapUpdate}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/GoogleServices/GetGoogleGeocodeFromLatLng?latitude=${lat}&longtitude=${lng}`)

        if(isFromSingleRouteMap){
            const updatedItem = thunkApi.getState().addLoad.selectedRouteItem
            thunkApi.dispatch(setSelectedRouteItem({...updatedItem, locationData: {...updatedItem.locationData, googleLocation: data.results[0].formatted_address, isfirstChanged:true, googleSearchText: data.results[0].formatted_address}}))
            thunkApi.dispatch(setAdresSelectMapZoom(12))
        }
        if(isFromSingleRouteMapUpdate) {
            const updatedItem = thunkApi.getState().updateLoad.selectedRouteItemUpdate
            thunkApi.dispatch(setSelectedRouteItemUpdate({...updatedItem, locationData: {...updatedItem.locationData, googleLocation: data.results[0].formatted_address, isfirstChanged:true, googleSearchText: data.results[0].formatted_address}}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


const addressSlice = createSlice({
    name: "address",
    initialState,
    reducers: {

        setAdresAutoComplete:(state, action) => {
            state.adresAutoCompleteOptions = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder

        .addCase(getAdresAutoComplete.pending, (state)=> {
            state.isLoadingGetAdresAutoComplete = true
        })
        .addCase(getAdresAutoComplete.fulfilled, (state, action)=> {
            state.isLoadingGetAdresAutoComplete = false
            state.adresAutoCompleteOptions = action.payload.filter(item => item.description.includes("Türkiye"))
        })

        .addCase(getAdresAutoComplete.rejected, (state, action)=> {
            state.isLoadingGetAdresAutoComplete = false
            state.isErrorNewPassword = true
        })

        .addCase(getAdresFromLatLng.pending, (state)=> {
            state.isLoadingGetAdresFromLatLng = true
        })
        .addCase(getAdresFromLatLng.fulfilled, (state, action)=> {
            state.isLoadingGetAdresFromLatLng = false
            state.getAdresFromLatLngResult = action.payload.results[0].formatted_address
        })

        .addCase(getAdresFromLatLng.rejected, (state, action)=> {
            state.isLoadingGetAdresFromLatLng = false
            state.isErrorNewPassword = true
        })
    }
})


export const {setAdresAutoComplete} = addressSlice.actions
export default addressSlice.reducer